import React from "react";
import t from "../../../../i18n";
import ModalForm from "@ui/Modal/Form";
import { usePost } from "../../../../api/useCall";
import type { Project } from "../../../../api/useProjects";
import Text from "@ui/Text";
import AdditionnalMessage from "@ui/AdditionnalMessage";
import { minutesToFractional } from "../../../../lib/time/minutes";
import { css } from "@linaria/core";

const ulCustom = css`
  list-style: disc;
  padding-left: 2em;
`;

interface P {
  project: Project;
  nbFilters: number;
  onRequestClose: () => void;
}

const DataFlowActivatedModalForm = ({ project, nbFilters, onRequestClose }: P) => {
  const updateDataFlowActivation = usePost("/projects/:projectId(uuid)/analyses/activationFlow");

  const handleSubmit = React.useCallback(async () => {
    await updateDataFlowActivation({
      routeParams: { projectId: project.id },
      body: { activationStatus: true },
    });
    return true;
  }, [project.id, updateDataFlowActivation]);

  return (
    <ModalForm
      onSubmit={handleSubmit}
      onRequestClose={onRequestClose}
      okButtonName={t("project.settings.modal.data_flow.activated.ok_button_name")}
    >
      <Text>{t("project.settings.modal.data_flow.activated.question.text")}</Text>
      <div>
        <Text>{t("project.settings.modal.data_flow.activated.criteria")}</Text>
        <ul className={ulCustom}>
          <li>
            {t(
              "project.settings.modal.data_flow.activated.criteria.interval_minimal",
              project.minutesBetweenActiveAnalysis,
              t(
                "project.settings.analyses.frequency_value",
                minutesToFractional(project.minutesBetweenActiveAnalysis),
              ),
            )}
          </li>
          <li>
            {t("project.settings.modal.data_flow.activated.criteria.activation_filter", nbFilters)}
          </li>
        </ul>
      </div>
      <AdditionnalMessage
        status="INFO"
        text={t("project.settings.modal.data_flow.activated.additionnal_message.info.text")}
      />
    </ModalForm>
  );
};

export default React.memo(DataFlowActivatedModalForm);

{
  /* project.settings.modal.data_flow.activated.criteria.activation_filter */
}
